(function (root) {
"use strict";
var K = typeof module !== "undefined" && module.exports ? require("./sudaderotas-kit.js") : root.SDRKit;
if (!K) return;
var f1 = K.f1;
function defs() {
return K.defsComunes() +
K.lin("papelT", [[0, "#2d6b55"], [1, "#1f4f3f"]]) +
K.lin("piedra", [[0, "#efe3d0"], [1, "#cbb89c"]]) +
K.lin("repisaM", [[0, "#9a5c30"], [1, "#6a3c1c"]]) +
K.linU("pisoM", [[0, "#7a4626"], [1, "#4f2c16"]], 1100, 1250) +
K.rad("fuego", [[0, "#fff4b0"], [.35, "#ffc040"], [.7, "#ff6a2a"], [1, "#c8283f", 0]], .5, .8, .6) +
K.rad("brillo", [[0, "#ffb050", .55], [1, "#ffb050", 0]]) +
K.rad("tapete", [[0, "#e8465c"], [.7, "#c22a42"], [1, "#8e1a30"]]) +
'<pattern id="tapiz" width="80" height="80" patternUnits="userSpaceOnUse"><rect width="80" height="80" fill="url(#papelT)"/><rect x="38" width="4" height="80" fill="#fff" opacity=".07"/><path d="M20 30 l4 8 9 1 -7 6 2 9 -8 -5 -8 5 2 -9 -7 -6 9 -1z" fill="#f7c64a" opacity=".55"/><circle cx="60" cy="68" r="4" fill="#f7c64a" opacity=".45"/></pattern>' +
'<pattern id="ladrillo" width="80" height="44" patternUnits="userSpaceOnUse"><rect width="80" height="44" fill="#a8452e"/><rect x="2" y="2" width="76" height="18" rx="3" fill="#c25a3c"/><rect x="-38" y="24" width="76" height="18" rx="3" fill="#b85036"/><rect x="42" y="24" width="76" height="18" rx="3" fill="#b85036"/></pattern>';
}
function guirnalda(x0, x1, y) {
var o = "", r = K.rng(3), cols = ["#e23c52", "#f7c64a", "#5bb8ff", "#ffffff"];
for (var x = x0; x < x1; x += 22) o += '<ellipse cx="' + f1(x) + '" cy="' + f1(y + Math.sin(x / 40) * 6) + '" rx="26" ry="14" fill="' + (r() > .5 ? "#2f8a5e" : "#3fa874") + '" transform="rotate(' + f1(r() * 60 - 30) + ' ' + f1(x) + ' ' + f1(y) + ')"/>';
for (x = x0 + 20; x < x1; x += 46) o += '<circle cx="' + f1(x) + '" cy="' + f1(y + 8 + Math.sin(x) * 6) + '" r="9" fill="' + cols[(x / 46 | 0) % 4] + '"/><circle cx="' + f1(x - 3) + '" cy="' + f1(y + 5 + Math.sin(x) * 6) + '" r="3" fill="#fff" opacity=".7"/>';
return o;
}
function vela(x, y) {
return '<circle cx="' + x + '" cy="' + (y - 70) + '" r="40" fill="url(#luzCalida)"/><rect x="' + (x - 14) + '" y="' + (y - 60) + '" width="28" height="60" rx="5" fill="#fff6ec"/>' +
'<path d="M' + x + ' ' + (y - 88) + ' q 10 14 0 24 q -10 -10 0 -24z" fill="#ffc040"/>';
}
function chimenea(yRep, conFuego) {
var o = '<rect x="180" y="' + (yRep + 40) + '" width="640" height="' + (1100 - yRep) + '" fill="url(#ladrillo)"/>' +
'<rect x="180" y="' + (yRep + 40) + '" width="640" height="' + (1100 - yRep) + '" fill="#000" opacity=".08"/>';
if (conFuego) {
var yb = yRep + 170;
o += '<path d="M300 1100 L300 ' + (yb + 80) + ' Q 300 ' + yb + ' 380 ' + yb + ' L620 ' + yb + ' Q 700 ' + yb + ' 700 ' + (yb + 80) + ' L700 1100Z" fill="#2b140c"/>' +
'<ellipse cx="500" cy="1000" rx="300" ry="220" fill="url(#brillo)"/>' +
'<path d="M360 1060 C 360 960, 430 960, 420 880 C 470 930, 470 980, 480 900 C 520 960, 540 860, 560 820 C 590 920, 640 940, 640 1060Z" fill="url(#fuego)"/>' +
'<rect x="340" y="1050" width="320" height="26" rx="12" fill="#6a3c1c"/><rect x="370" y="1034" width="260" height="22" rx="10" fill="#8a5230" transform="rotate(-4 500 1045)"/>';
}
o += '<rect x="150" y="' + yRep + '" width="700" height="46" rx="8" fill="url(#repisaM)"/><rect x="150" y="' + yRep + '" width="700" height="10" rx="5" fill="#fff" opacity=".2"/>' +
'<rect x="168" y="' + (yRep + 46) + '" width="664" height="12" fill="#000" opacity=".2"/>';
return o;
}
function frente() {
var b = K.fondo("url(#tapiz)") + chimenea(470, true) +
vela(230, 470) + vela(770, 470) + guirnalda(150, 860, 470) +
'<g transform="translate(500 380)"><circle r="78" fill="none" stroke="#2f8a5e" stroke-width="30"/><circle r="78" fill="none" stroke="#3fa874" stroke-width="12" stroke-dasharray="10 14"/>' +
'<path d="M0 70 l-34 34 l12 2 l-4 14 l26 -30 l26 30 l-4 -14 l12 -2z" fill="#e23c52"/><circle cy="74" r="12" fill="#c42a44"/></g>' +
'<rect x="-400" y="1100" width="1800" height="900" fill="url(#pisoM)"/>';
return K.svgSangrado(defs(), b);
}
function encima() {
return K.svg(1000, 1250, defs(),
'<ellipse cx="500" cy="1090" rx="430" ry="110" fill="#000" opacity=".2"/><ellipse cx="500" cy="1075" rx="420" ry="100" fill="url(#tapete)"/>' +
'<ellipse cx="500" cy="1075" rx="380" ry="82" fill="none" stroke="#fff6ec" stroke-width="5" stroke-dasharray="14 10" opacity=".8"/>' +
'<ellipse cx="500" cy="1075" rx="300" ry="58" fill="none" stroke="#f7c64a" stroke-width="4" opacity=".7"/>');
}
function espalda() {
var b = K.fondo("url(#tapiz)") + chimenea(330, true) + guirnalda(150, 860, 330) +
vela(215, 330) + vela(785, 330) + '<rect x="-400" y="1100" width="1800" height="900" fill="url(#pisoM)"/>';
return K.svgSangrado(defs(), b);
}
function manga() { return K.svg(600, 1400, defs(), '<rect width="600" height="1400" fill="url(#tapiz)"/>' + K.estrellas(14, 0, 0, 600, 1400, 7, "#fff6c9", 6, 12)); }
function capucha() {
var b = '<rect width="900" height="900" fill="#8e1a30"/>';
for (var y = 0; y < 900; y += 60) b += '<rect y="' + y + '" width="900" height="30" fill="#a8233a"/>';
b += K.estrellas(30, 0, 0, 900, 900, 11, "#f7c64a", 8, 16);
return K.svg(900, 900, defs(), b);
}
var COLS = [["#e23c52", "#fff6ec"], ["#2f9e6a", "#fff6ec"], ["#f7c64a", "#e23c52"]];
var D = {
id: "chimenea", nombre: "Junto a la chimenea", max: 3, despuesDe: "renos",
arte: { frente: frente, encima: encima, espalda: espalda, manga: manga, capucha: capucha },
fondo: function (ctx, w, h) {
ctx.fillStyle = "#1f4f3f"; ctx.fillRect(0, 0, w, h); ctx.fillStyle = "rgba(247,198,74,.4)"; var r = K.rng(4);
for (var i = 0; i < w * h / 9000; i++) { ctx.beginPath(); ctx.arc(r() * w, r() * h, 3 + r() * 4, 0, 7); ctx.fill(); }
},
resorte: function (ctx, x, y, w, h) {
K.resorte(ctx, x, y, w, h, { c1: "#2d6b55", c2: "#1f4f3f", linea: "rgba(247,198,74,.9)", paso: 40, motivo: function (c, xx, yy, u) { K.motivoCorazon(c, xx, yy, u * 1.2, "#e23c52"); } });
},
dibujar: {
frente: function (ctx, estado, fotos, K) {
var A = K.A, cajas = K.mascotas(ctx, estado, fotos, 760, [.95, .86, .78]);
cajas.forEach(function (b) { K.bufanda(ctx, b.x + b.w / 2, b.y + b.h * .84, b.w * .78, "#2f9e6a", "#fff6ec"); });
var enc = K.arte("chimenea", "encima"); if (enc) ctx.drawImage(enc, 0, 0, 1000, 1250);
K.letras(ctx, K.capital(estado.frase), 500, 240, 100, 660, "#f7c64a", "#7a3b14", { borde: "#fff6ec" });
var nom = A.nombres(estado);
if (nom) { K.cinta(ctx, 500, 1040, 420, 92, "#f7c64a", "#c98a16"); K.letras(ctx, K.capital(nom), 500, 1044, 62, 360, "#7a1428", null, { borde: false }); }
},
espalda: function (ctx, estado, fotos, K) {
var n = Math.max(1, Math.min(estado.cantidad || 1, 3)), xs = n === 1 ? [500] : n === 2 ? [355, 645] : [270, 500, 730], w = n === 1 ? 230 : n === 2 ? 210 : 175;
xs.forEach(function (x, i) { var m = (estado.mascotas || [])[i] || {}; K.calcetinNombre(ctx, x, 400, w, K.capital((m.nombre || "").trim()), COLS[i][0], COLS[i][1]); });
K.cinta(ctx, 500, 905, 460, 92, "#e8465c", "#a8233a");
ctx.save(); ctx.font = "700 48px " + K.FRED; ctx.textAlign = "center"; ctx.textBaseline = "middle"; ctx.fillStyle = "#fff";
try { ctx.letterSpacing = "6px"; } catch (e) {}
ctx.fillText("NAVIDAD " + K.anio(), 500, 910); ctx.restore();
}
}
};
if (typeof module !== "undefined" && module.exports) module.exports = D; else K.registrar(D);
})(this);